<div class="list-item" [ngClass]="{ 'list-item--no-icon': !image }">
  <div *ngIf="image" class="list-item__icon">
    <img [src]="'assets/images/' + image" alt="Icono del servicio" />
  </div>
  <div class="list-item__box">
    <div>
      <div class="list-item__title">{{ data.title }}</div>
      <div class="list-item__subtitle-1">{{ data.subtitle1 }}</div>
    </div>
    <div class="list-item__subtitle-2">{{ data.subtitle2 }}</div>
  </div>
</div>
